<template>
    <div class="saas-page profile-command-page">
        <div class="saas-hero card-saas profile-command-hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/user">{{ trans('user.user') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{ trans('user.avatar') }}</span>
                </p>
                <h1 class="saas-hero__title">{{ userForm.first_name }} {{ userForm.last_name }}</h1>
                <p class="profile-command-hero__subtitle">{{ trans('user.avatar') }}</p>
            </div>
        </div>
        <div class="nk-block">
            <div class="card-saas card-saas--flush admin-user-profile-card">
                <div class="card-aside-wrap">
                    <div class="card-content">
                        <user-sidebar menu="avatar" :id="id"></user-sidebar>
                        <div class="card-inner admin-user-form-inner">
                            <div class="nk-block">
                                <div class="nk-block-head admin-user-form-head">
                                    <h4 class="admin-user-section-title">{{trans('user.avatar')}}</h4>
                                </div>
                                <upload-image
                                    :id="'user-avatar-' + id"
                                    presentation="avatar"
                                    :upload-path="`/user/profile/avatar/${id}`"
                                    :remove-path="`/user/profile/avatar/remove/${id}`"
                                    :image-source="avatar.user"
                                    @uploaded="updateAvatar"
                                    @removed="updateAvatar"
                                ></upload-image>
                            </div>
                        </div>
                    </div>
                    <div class="card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-xxl" data-content="userAside" data-toggle-screen="xxl" data-toggle-overlay="true" data-toggle-body="true">
                        <div class="card-inner-group" data-simplebar>
                            <user-summary :user="user"></user-summary>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import userSidebar from './user-sidebar'
    import uploadImage from '../../components/upload-image'
    import userSummary from './summary'

    export default {
        components : { userSidebar,uploadImage,userSummary },
        data() {
            return {
                id:this.$route.params.id,
                user: '',
                userForm: new Form({
                    first_name: '',
                    last_name: '',
                },false),
                avatar: {
                    user: ''
                }
            };
        },
        mounted(){
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            axios.get('/api/user/'+this.id)
                .then(response => response.data)
                .then(response => {
                    this.user = response.user;
                    this.userForm.first_name = response.user.profile.first_name;
                    this.userForm.last_name = response.user.profile.last_name;
                    this.avatar.user = response.user.profile.avatar;
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                    this.$router.push('/user');
                })
        },
        methods: {
            updateAvatar(val){
                if(helper.getAuthUser('id') == this.id){
                    this.$store.dispatch('setAuthUserDetail',{
                        avatar: val
                    });
                }
                this.user.profile.avatar = val;
            }
        }
    }
</script>

<style scoped>
.profile-command-page {
    --linear-accent: #625cf6;
    --linear-line: #e5e7eb;
    --linear-muted: #64748b;
}

.profile-command-hero,
.admin-user-profile-card {
    border-color: var(--linear-line);
    background: #ffffff;
}

.profile-command-hero__subtitle {
    margin: 0.25rem 0 0;
    color: var(--linear-muted);
    font-size: 0.8125rem;
    font-weight: 500;
}

.admin-user-form-inner {
    background: transparent;
}

.admin-user-section-title {
    color: #0f172a;
    font-weight: 600;
    letter-spacing: -0.02em;
}
</style>
